import React, { useContext, useEffect, useMemo } from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import FormsMenu from './FormsMenu';
import DraftingContextProvider, { FormsContext } from './context/FormsContext';
import FormsContent from './FormsContent';
import useForms from './hooks/useForms';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { useHideClinicFormsByClinicId } from './useHideClinicFormsByClinicId';

const Forms = (): JSX.Element => {
  const { currentClinicId } = useClinicUser();
  const { formId } = useContext(FormsContext);
  const { data, getFormTemplates } = useForms();
  const formsHidden = useHideClinicFormsByClinicId();

  useEffect(() => {
    if (formId) {
      getFormTemplates();
    }
  }, [formId, getFormTemplates]);

  const clinicTemplates = useMemo(
    () => data?.findManyFormTemplate?.slice().sort((a, b) => a.title.localeCompare(b.title)) || [],
    [data?.findManyFormTemplate],
  );

  if (formsHidden) {
    return <></>;
  }
  return (
    <DraftingContextProvider>
      <Flex h="100%">
        <FormsMenu clinicId={currentClinicId} clinicTemplates={clinicTemplates} getFormTemplates={getFormTemplates} />
        <FormsContent />
      </Flex>
    </DraftingContextProvider>
  );
};

export default Forms;
